export default function IndexSection() {
  const items = [
    { letter: '日', name: '日本漫画', count: '3.2万部', icon: 'ri-earth-line' },
    { letter: '韩', name: '韩国漫画', count: '1.8万部', icon: 'ri-kakao-talk-line' },
    { letter: '国', name: '国产漫画', count: '2.5万部', icon: 'ri-china-railway-line' },
    { letter: '恋', name: '恋爱漫画', count: '8,600部', icon: 'ri-heart-line' },
    { letter: '战', name: '热血战斗', count: '6,200部', icon: 'ri-fire-line' },
    { letter: '古', name: '古风漫画', count: '3,500部', icon: 'ri-brush-line' },
    { letter: '悬', name: '悬疑推理', count: '4,100部', icon: 'ri-search-eye-line' },
  ];

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">分类索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按漫画类型和地区快速浏览，精准找到你喜欢的漫画品类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 md:gap-4 max-w-5xl mx-auto">
          {items.map((item, i) => (
            <a
              key={i}
              href="#cards"
              className="flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <span className="text-lg font-heading font-bold text-accent-600">{item.letter}</span>
              </div>
              <span className="text-sm font-medium text-foreground-800 mb-1">{item.name}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#cards" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
            浏览全部分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}